export type AudienceFilterVariant = 'inclusion' | 'exclusion';

/**
 * Per-variant Tailwind classes used to colour-code the Inclusions (green) and
 * Exclusions (amber) sections of the audience builder. Shared between
 * AudienceFilterField (section chrome) and OrFilterField (filter cards).
 */
export const AUDIENCE_FILTER_VARIANT_STYLES: Record<
	AudienceFilterVariant,
	{
		/** Section heading text colour. */
		heading: string;
		/** Background + border of each AND filter card. */
		card: string;
		/** "OR" chip shown between alternatives inside a card. */
		orChip: string;
		/** "AND" chip shown between filter cards. */
		andChip: string;
		/** Colour of the line behind the OR / AND chips. */
		line: string;
		/** Primary-style "Add group" button, coloured to match the section. */
		addGroupButton: string;
	}
> = {
	inclusion: {
		heading: 'admin:text-green-700',
		card: 'admin:border-green-500 admin:bg-green-50/30',
		orChip: 'admin:rounded-full admin:border admin:border-green-300 admin:bg-green-100 admin:px-3 admin:text-green-700',
		andChip: 'admin:rounded-full admin:bg-green-600 admin:px-4 admin:py-1 admin:font-bold admin:text-white',
		line: 'admin:bg-green-500',
		addGroupButton: 'admin:border-green-600! admin:bg-green-600! admin:text-white! admin:hover:bg-green-700!',
	},
	exclusion: {
		heading: 'admin:text-amber-700',
		card: 'admin:border-amber-200 admin:bg-amber-50/30',
		orChip: 'admin:rounded-full admin:border admin:border-amber-300 admin:bg-amber-100 admin:px-3 admin:text-amber-700',
		andChip: 'admin:rounded-full admin:bg-amber-600 admin:px-4 admin:py-1 admin:font-bold admin:text-white',
		line: 'admin:bg-amber-300',
		addGroupButton: 'admin:border-amber-500! admin:bg-amber-500! admin:text-white! admin:hover:bg-amber-600!',
	},
};
